import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetohyderabadcab() {



    const cardData = {

keyword: "Pune to Hyderabad Cab",

headingDescription:
    "Rising Cab Service offers safe, reliable, and comfortable Pune to Hyderabad Cab services for families, business travelers, students, and tourists. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles driven by experienced chauffeurs for long-distance highway travel. Our service includes one-way and round-trip options, doorstep pickup from Pune, 24/7 booking support, and transparent pricing. Whether you are traveling for corporate meetings, family visits, or leisure trips, Rising Cab Service ensures a smooth and hassle-free journey from Pune to Hyderabad.",

topPlaces: [
    {
        title: "Charminar",
        description:
            "Charminar is the most iconic landmark of Hyderabad, built in 1591. It is famous for its historic architecture, bustling markets, and cultural significance in the heart of the city."
    },
    {
        title: "Golconda Fort",
        description:
            "Golconda Fort is a historic fortress known for its grand architecture, acoustic design, and panoramic views of Hyderabad. It reflects the rich heritage of the Qutb Shahi dynasty."
    },
    {
        title: "Hussain Sagar Lake",
        description:
            "Hussain Sagar Lake is a large artificial lake connecting Hyderabad and Secunderabad, famous for the massive Buddha statue in the center and beautiful evening views."
    },
    {
        title: "Ramoji Film City",
        description:
            "Ramoji Film City is one of the largest film studio complexes in the world, offering film sets, theme parks, and entertainment experiences for tourists."
    },
    {
        title: "Birla Mandir",
        description:
            "Birla Mandir is a stunning white marble temple dedicated to Lord Venkateswara, located on a hill offering panoramic views of Hyderabad city."
    },
    {
        title: "Chowmahalla Palace",
        description:
            "Chowmahalla Palace showcases the royal heritage of the Nizams, featuring grand halls, courtyards, and artifacts reflecting Hyderabad's rich history."
    },
    {
        title: "Salar Jung Museum",
        description:
            "Salar Jung Museum is one of India’s largest museums, housing a vast collection of art, sculptures, manuscripts, and antiques from around the world."
    },
    {
        title: "Shilparamam",
        description:
            "Shilparamam is a cultural village in Hyderabad showcasing traditional arts, crafts, and performances, making it a great place to experience local culture."
    },
    {
        title: "Necklace Road",
        description:
            "Necklace Road is a scenic waterfront boulevard along Hussain Sagar Lake, popular for evening walks, cycling, and dining experiences."
    },
    {
        title: "Lumbini Park",
        description:
            "Lumbini Park is a well-maintained urban park near Hussain Sagar offering boating, laser shows, and family-friendly recreation activities."
    }
],



services: [
    {
        name: "Pune to Hyderabad Cab",
        description:
            "Rising Cab Service offers Pune to Hyderabad Cab for safe, reliable, and comfortable long-distance travel between Maharashtra and Telangana. This service is ideal for business trips, family travel, relocation, and tourism. We provide well-maintained AC vehicles including hatchbacks, sedans, SUVs, Innova, and Innova Crysta with experienced long-route drivers trained for highway and expressway driving. Customers can choose one-way or round-trip options with door-to-door pickup and drop service. With 24x7 availability, transparent pricing, and professional support, we ensure a smooth and stress-free intercity journey from Pune to Hyderabad."
    },
    {
        name: "Pune to Hyderabad Taxi",
        description:
            "Book Pune to Hyderabad Taxi with Rising Cab Service for affordable and comfortable intercity travel. Our taxis are suitable for solo travelers, families, and corporate passengers who need safe, punctual, and reliable long-distance transportation with professional chauffeurs."
    },
    {
        name: "Cab from Pune to Hyderabad",
        description:
            "Rising Cab Service provides Cab from Pune to Hyderabad with flexible booking options, clean AC vehicles, and experienced drivers ensuring safe highway travel with timely pickups and drop-offs."
    },
    {
        name: "Taxi from Pune to Hyderabad",
        description:
            "Our Taxi from Pune to Hyderabad service ensures smooth, safe, and comfortable travel with well-trained drivers, well-maintained vehicles, and budget-friendly pricing for long-distance journeys."
    },
    {
        name: "Pune to Hyderabad Cab Service",
        description:
            "Rising Cab Service offers Pune to Hyderabad Cab Service with reliable booking support, professional drivers, and high-quality vehicles for a comfortable intercity travel experience."
    },
    {
        name: "Pune to Hyderabad Taxi Fare",
        description:
            "Get transparent Pune to Hyderabad Taxi Fare with no hidden charges. We offer competitive pricing for one-way, round-trip, and customized travel packages based on distance, vehicle type, and travel requirements."
    },
    {
        name: "Pune to Hyderabad One Way Cab",
        description:
            "Book Pune to Hyderabad One Way Cab for cost-effective long-distance travel with comfortable vehicles, experienced drivers, and door-to-door service without return charges."
    },
    {
        name: "Pune to Hyderabad Round Trip Taxi",
        description:
            "Rising Cab Service provides Pune to Hyderabad Round Trip Taxi with flexible return schedules, waiting options, and customized travel plans for families, business travelers, and groups."
    },
    {
        name: "Pune to Hyderabad Cab Booking",
        description:
            "Our Pune to Hyderabad Cab Booking service offers instant confirmation, multiple vehicle choices, and 24x7 support for easy and hassle-free intercity travel planning."
    },
    {
        name: "Cheap Pune to Hyderabad Cab",
        description:
            "Rising Cab Service offers Cheap Pune to Hyderabad Cab with affordable pricing while ensuring safety, comfort, and reliable long-route travel experience."
    },
    {
        name: "Best Pune to Hyderabad Taxi",
        description:
            "Choose the Best Pune to Hyderabad Taxi with Rising Cab Service for premium comfort, punctual service, and experienced long-distance drivers ensuring a smooth journey."
    },
    {
        name: "Sedan Pune to Hyderabad Cab",
        description:
            "Our Sedan Pune to Hyderabad Cab is ideal for individuals and small families looking for economical and comfortable long-distance travel with AC comfort and smooth rides."
    },
    {
        name: "SUV Pune to Hyderabad Taxi",
        description:
            "Book SUV Pune to Hyderabad Taxi for spacious seating, extra luggage capacity, and comfortable group travel on long highway routes between Pune and Hyderabad."
    },
    {
        name: "Innova Pune to Hyderabad Cab",
        description:
            "Rising Cab Service offers Innova Pune to Hyderabad Cab for families and groups seeking premium comfort, ample space, and smooth long-distance travel experience."
    },
    {
        name: "Long Distance Cab Pune Hyderabad",
        description:
            "Our Long Distance Cab Pune Hyderabad service ensures safe, reliable, and comfortable intercity travel with experienced drivers and well-maintained vehicles for highway journeys."
    },
    {
        name: "24x7 Pune to Hyderabad Cab Service",
        description:
            "Book 24x7 Pune to Hyderabad Cab Service with Rising Cab Service for round-the-clock availability, quick response, and reliable long-distance transportation anytime you need."
    },
    {
        name: "Outstation Cab Pune to Hyderabad",
        description:
            "Rising Cab Service provides Outstation Cab Pune to Hyderabad for safe and comfortable intercity travel with flexible pickup options and professional chauffeurs."
    },
    {
        name: "Pune to Hyderabad Airport Cab",
        description:
            "Our Pune to Hyderabad Airport Cab service ensures timely airport transfers with flight tracking, punctual pickups, and stress-free travel experience."
    },
    {
        name: "Pune to Hyderabad Airport Taxi",
        description:
            "Book Pune to Hyderabad Airport Taxi for reliable airport drop and pickup service with clean AC vehicles and professional drivers available 24x7."
    },
    {
        name: "Pune to Rajiv Gandhi International Airport Cab",
        description:
            "Rising Cab Service offers Pune to Rajiv Gandhi International Airport Cab with safe, punctual, and comfortable transfers ensuring on-time arrival for all flights."
    },
    {
        name: "Pune to Hyderabad Airport Cab Service",
        description:
            "Our Pune to Hyderabad Airport Cab Service provides reliable airport transportation with well-maintained vehicles, experienced drivers, and 24x7 availability."
    }
],
tableData: [
    ["Pune to Hyderabad Cab", "Pune to Hyderabad Taxi"],
    ["Cab from Pune to Hyderabad", "Taxi from Pune to Hyderabad"],
    ["Pune to Hyderabad One Way Cab", "Pune to Hyderabad Round Trip Taxi"],
    ["Pune to Hyderabad Cab Service", "Pune to Hyderabad Taxi Fare"],
    ["Cheap Pune to Hyderabad Cab", "Best Pune to Hyderabad Taxi"],
    ["Sedan Pune to Hyderabad Cab", "SUV Pune to Hyderabad Taxi"],
    ["Innova Pune to Hyderabad Cab", "Long Distance Cab Pune Hyderabad"],
    ["24x7 Pune to Hyderabad Cab Service", "Outstation Cab Pune to Hyderabad"],
    ["Pune to Hyderabad Airport Cab", "Pune to Hyderabad Airport Taxi"],
    ["Pune to Rajiv Gandhi Airport Cab", "Pune to Hyderabad Airport Cab Service"]
],




whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Hyderabad Cab Service",
        WhyChoosedescription: "Rising Cab Service provides comfortable Pune to Hyderabad cab transportation for business travelers, families, tourists, students, and long-distance travelers."
    },
    {
        WhyChooseheading: "Ideal for Interstate Travel",
        WhyChoosedescription: "Travel conveniently between Maharashtra and Telangana with professionally managed transportation designed for both personal and corporate travel requirements."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Long Journeys",
        WhyChoosedescription: "Our fleet includes Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles to ensure a pleasant travel experience."
    },
    {
        WhyChooseheading: "Flexible Travel Packages Available",
        WhyChoosedescription: "Customers can choose one-way cab services, round trips, multi-day bookings, and customized itineraries based on their travel plans."
    },
    {
        WhyChooseheading: "Popular for Business and Family Visits",
        WhyChoosedescription: "Many passengers use our Pune to Hyderabad cab service for corporate meetings, family functions, educational visits, medical travel, and vacations."
    },
    {
        WhyChooseheading: "Pickup Service from Any Pune Location",
        WhyChoosedescription: "Doorstep pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and surrounding areas."
    },
    {
        WhyChooseheading: "Safe Highway Travel with Experienced Drivers",
        WhyChoosedescription: "Our trained drivers are experienced on interstate routes and ensure smooth, secure, and comfortable travel throughout the journey."
    },
    {
        WhyChooseheading: "Customized Stops During the Journey",
        WhyChoosedescription: "Passengers can include meal breaks, overnight halts, sightseeing locations, and business stops according to their travel preferences."
    }
]
};

const faqData = [
    {
        question: "Why do travelers choose road travel from Pune to Hyderabad?",
        answer: "Road travel offers flexibility, personalized schedules, comfortable transportation, and convenient doorstep pickup and drop services."
    },
    {
        question: "Can I book a one-way cab from Pune to Hyderabad?",
        answer: "Yes, one-way transportation is available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is recommended for Pune to Hyderabad travel?",
        answer: "Ertiga, Innova Crysta, SUVs, and Tempo Travellers are popular choices for long-distance comfort and luggage space."
    },
    {
        question: "Do you provide cabs for corporate travel to Hyderabad?",
        answer: "Yes, many professionals and companies use our service for business meetings, conferences, client visits, and official travel."
    },
    {
        question: "Can families travel comfortably on this route?",
        answer: "Yes, spacious vehicles with comfortable seating make the journey suitable for families, children, and senior citizens."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for family tours, corporate teams, and group transportation."
    },
    {
        question: "Can multiple cities be covered during the trip?",
        answer: "Yes, customized itineraries can include additional destinations and travel stops based on customer requirements."
    },
    {
        question: "Is pickup available from Pune Airport and Railway Station?",
        answer: "Yes, passengers can begin their journey from Pune Airport, Railway Station, hotels, offices, or residential addresses."
    },
    {
        question: "Should customers book in advance for Pune to Hyderabad travel?",
        answer: "Advance booking is recommended to secure preferred vehicles and ensure smooth travel planning."
    },
    {
        question: "How can I reserve a Pune to Hyderabad Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rakesh Agrawal",
        feedback:
            "Our corporate team needed reliable transportation to Hyderabad, and Rising Cab Service delivered a seamless experience. The vehicle quality and driver professionalism were exceptional.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sneha Kulkarni",
        feedback:
            "Traveling to Hyderabad with family felt surprisingly comfortable despite the long distance. The journey was well planned, and every aspect of the trip was handled efficiently.",
        rating: 5
    }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Hyderabad Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-hyderabad-cab.jpg",
"description": "Book Pune to Hyderabad Cab Service with Rising Cab Service for safe, comfortable, and long-distance travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars at affordable prices.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-hyderabad-cab"
}
};





    return (
        <div>


<Helmet>
  <title>Pune to Hyderabad Cab Service | Long Distance Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Hyderabad Cab Service for safe and comfortable long-distance travel. Get affordable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to hyderabad cab, pune to hyderabad taxi, cab from pune to hyderabad, taxi from pune to hyderabad, pune to hyderabad cab service, pune to hyderabad taxi fare, pune to hyderabad one way cab, pune to hyderabad round trip taxi, pune to hyderabad cab booking, cheap pune to hyderabad cab, best pune to hyderabad taxi, sedan pune to hyderabad cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/44.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetohyderabadcab;